(function () {

    var laroute = (function () {

        var routes = {

            absolute: false,
            rootUrl: 'https://app.clarkdiamonds.com',
            routes : [{"host":null,"methods":["GET","HEAD"],"uri":"_debugbar\/open","name":"debugbar.openhandler","action":"Barryvdh\Debugbar\Controllers\OpenHandlerController@handle"},{"host":null,"methods":["GET","HEAD"],"uri":"_debugbar\/clockwork\/{id}","name":"debugbar.clockwork","action":"Barryvdh\Debugbar\Controllers\OpenHandlerController@clockwork"},{"host":null,"methods":["GET","HEAD"],"uri":"_debugbar\/assets\/stylesheets","name":"debugbar.assets.css","action":"Barryvdh\Debugbar\Controllers\AssetController@css"},{"host":null,"methods":["GET","HEAD"],"uri":"_debugbar\/assets\/javascript","name":"debugbar.assets.js","action":"Barryvdh\Debugbar\Controllers\AssetController@js"},{"host":null,"methods":["GET","HEAD"],"uri":"auth\/login","name":null,"action":"App\Http\Controllers\Auth\AuthController@getLogin"},{"host":null,"methods":["POST"],"uri":"auth\/login","name":null,"action":"App\Http\Controllers\Auth\AuthController@postLogin"},{"host":null,"methods":["GET","HEAD"],"uri":"auth\/logout","name":null,"action":"App\Http\Controllers\Auth\AuthController@getLogout"},{"host":null,"methods":["GET","HEAD"],"uri":"\/","name":null,"action":"Closure"},{"host":null,"methods":["GET","HEAD"],"uri":"search","name":"public.diamonds.search","action":"App\Http\Controllers\PublicDiamondsController@index"},{"host":null,"methods":["GET","HEAD"],"uri":"datatables\/index\/{one?}\/{two?}\/{three?}\/{four?}\/{five?}","name":null,"action":"App\Http\Controllers\Ajax\AjaxDiamondSearchController@getIndex"},{"host":null,"methods":["GET","HEAD"],"uri":"datatables","name":null,"action":"App\Http\Controllers\Ajax\AjaxDiamondSearchController@getIndex"},{"host":null,"methods":["GET","HEAD","POST","PUT","PATCH","DELETE"],"uri":"datatables\/data\/{one?}\/{two?}\/{three?}\/{four?}\/{five?}","name":"datatables.data","action":"App\Http\Controllers\Ajax\AjaxDiamondSearchController@anyData"},{"host":null,"methods":["GET","HEAD","POST","PUT","PATCH","DELETE"],"uri":"datatables\/{_missing}","name":null,"action":"App\Http\Controllers\Ajax\AjaxDiamondSearchController@missingMethod"},{"host":null,"methods":["GET","HEAD"],"uri":"ajaxOrder\/orders\/{one?}\/{two?}\/{three?}\/{four?}\/{five?}","name":"ajaxOrder.data","action":"App\Http\Controllers\Ajax\AjaxOrdersController@getOrders"},{"host":null,"methods":["GET","HEAD","POST","PUT","PATCH","DELETE"],"uri":"ajaxOrder\/{_missing}","name":null,"action":"App\Http\Controllers\Ajax\AjaxOrdersController@missingMethod"},{"host":null,"methods":["GET","HEAD"],"uri":"diamond\/{diamond_id}","name":"public.diamond.show","action":"App\Http\Controllers\PublicDiamondsController@show"},{"host":null,"methods":["POST"],"uri":"cart\/add\/{diamond_id}","name":"public.cart.addItem","action":"App\Http\Controllers\Ajax\AjaxCartController@addDiamond"},{"host":null,"methods":["DELETE"],"uri":"cart\/delete\/{diamond_id}","name":"public.cart.removeItem","action":"App\Http\Controllers\Ajax\AjaxCartController@delete"},{"host":null,"methods":["GET","HEAD"],"uri":"cart\/checkout","name":"public.cart.checkout","action":"App\Http\Controllers\CartController@checkout"},{"host":null,"methods":["POST"],"uri":"cart\/checkout","name":"public.cart.processCheckout","action":"App\Http\Controllers\CartController@processCheckout"},{"host":null,"methods":["DELETE"],"uri":"cart","name":"public.cart.destroy","action":"App\Http\Controllers\Ajax\AjaxCartController@destroy"},{"host":null,"methods":["GET","HEAD"],"uri":"cart\/count","name":"public.cart.count","action":"App\Http\Controllers\Ajax\AjaxCartController@count"},{"host":null,"methods":["GET","HEAD"],"uri":"cart","name":"public.cart.index","action":"App\Http\Controllers\CartController@index"},{"host":null,"methods":["GET","HEAD"],"uri":"user\/filters","name":"user.filters","action":"App\Http\Controllers\FiltersController@index"},{"host":null,"methods":["POST"],"uri":"filter\/store","name":"filter.store","action":"App\Http\Controllers\FiltersController@store"},{"host":null,"methods":["POST"],"uri":"filter\/nameCheck","name":"filter.nameCheck","action":"App\Http\Controllers\FiltersController@nameCheck"},{"host":null,"methods":["GET","HEAD"],"uri":"filter\/{filter_id}","name":"filter.recover","action":"App\Http\Controllers\FiltersController@recoverFilter"},{"host":null,"methods":["GET","HEAD"],"uri":"filter\/{filter_id}\/edit","name":"filter.edit","action":"App\Http\Controllers\FiltersController@edit"},{"host":null,"methods":["POST"],"uri":"filter\/{filter_id}\/edit","name":"filter.update","action":"App\Http\Controllers\FiltersController@update"},{"host":null,"methods":["DELETE"],"uri":"filter\/{filter_id}","name":"filter.delete","action":"App\Http\Controllers\FiltersController@delete"},{"host":null,"methods":["GET","HEAD"],"uri":"order","name":"public.order.index","action":"App\Http\Controllers\OrdersController@index"},{"host":null,"methods":["GET","HEAD"],"uri":"order\/{order_id}","name":"public.order.show","action":"App\Http\Controllers\OrdersController@show"},{"host":null,"methods":["GET","HEAD"],"uri":"manager\/company\/create","name":"manager.company.create","action":"App\Http\Controllers\CompanyController@create"},{"host":null,"methods":["POST"],"uri":"manager\/company\/create","name":"manager.company.store","action":"App\Http\Controllers\CompanyController@store"},{"host":null,"methods":["GET","HEAD"],"uri":"manager\/company\/{company_id}\/edit","name":"manager.company.edit","action":"App\Http\Controllers\CompanyController@edit"},{"host":null,"methods":["PUT"],"uri":"manager\/company\/{company_id}\/edit","name":"manager.company.update","action":"App\Http\Controllers\CompanyController@update"},{"host":null,"methods":["DELETE"],"uri":"manager\/company\/{company_id}","name":"manager.company.delete","action":"App\Http\Controllers\CompanyController@delete"},{"host":null,"methods":["GET","HEAD"],"uri":"manager\/companies","name":"manager.companies","action":"App\Http\Controllers\CompanyController@index"},{"host":null,"methods":["GET","HEAD"],"uri":"manager\/user\/create","name":"manager.user.create","action":"App\Http\Controllers\UsersController@create"},{"host":null,"methods":["POST"],"uri":"manager\/user\/create","name":"manager.user.store","action":"App\Http\Controllers\UsersController@store"},{"host":null,"methods":["GET","HEAD"],"uri":"manager\/user\/{user_id}\/edit","name":"manager.user.edit","action":"App\Http\Controllers\UsersController@edit"},{"host":null,"methods":["PUT"],"uri":"manager\/user\/{user_id}\/edit","name":"manager.user.update","action":"App\Http\Controllers\UsersController@update"},{"host":null,"methods":["DELETE"],"uri":"manager\/user\/{user_id}","name":"manager.user.delete","action":"App\Http\Controllers\UsersController@delete"},{"host":null,"methods":["GET","HEAD"],"uri":"manager\/users","name":"manager.users","action":"App\Http\Controllers\UsersController@index"},{"host":null,"methods":["GET","HEAD"],"uri":"manager\/statistics","name":"manager.statistics.show","action":"App\Http\Controllers\SearchStatisticsController@show"},{"host":null,"methods":["GET","HEAD"],"uri":"manager\/statistics\/weight\/{days?}","name":"manager.statistics.weight","action":"App\Http\Controllers\Ajax\AjaxSearchStatistics@weightInRangeDates"},{"host":null,"methods":["GET","HEAD"],"uri":"manager\/statistics\/clarity\/{days?}","name":"manager.statistics.clarity","action":"App\Http\Controllers\Ajax\AjaxSearchStatistics@clarityInRangeDates"},{"host":null,"methods":["GET","HEAD"],"uri":"manager\/statistics\/cut\/{days?}","name":"manager.statistics.cut","action":"App\Http\Controllers\Ajax\AjaxSearchStatistics@cutInRangeDates"},{"host":null,"methods":["GET","HEAD"],"uri":"manager\/statistics\/color\/{days?}","name":"manager.statistics.color","action":"App\Http\Controllers\Ajax\AjaxSearchStatistics@colorInRangeDates"},{"host":null,"methods":["GET","HEAD"],"uri":"manager\/statistics\/price\/{days?}","name":"manager.statistics.price","action":"App\Http\Controllers\Ajax\AjaxSearchStatistics@priceInRangeDates"}],
            prefix: '',

            route : function (name, parameters, route) {
                route = route || this.getByName(name);

                if ( ! route ) {
                    return undefined;
                }

                return this.toRoute(route, parameters);
            },

            url: function (url, parameters) {
                parameters = parameters || [];

                var uri = url + '/' + parameters.join('/');

                return this.getCorrectUrl(uri);
            },

            toRoute : function (route, parameters) {
                var uri = this.replaceNamedParameters(route.uri, parameters);
                var qs  = this.getRouteQueryString(parameters);

                return this.getCorrectUrl(uri + qs);
            },

            replaceNamedParameters : function (uri, parameters) {
                uri = uri.replace(/\{(.*?)\??\}/g, function(match, key) {
                    if (parameters.hasOwnProperty(key)) {
                        var value = parameters[key];
                        delete parameters[key];
                        return value;
                    } else {
                        return match;
                    }
                });

                // Strip out any optional parameters that were not given
                uri = uri.replace(/\/\{.*?\?\}/g, '');

                return uri;
            },

            getRouteQueryString : function (parameters) {
                var qs = [];
                for (var key in parameters) {
                    if (parameters.hasOwnProperty(key)) {
                        qs.push(key + '=' + parameters[key]);
                    }
                }

                if (qs.length < 1) {
                    return '';
                }

                return '?' + qs.join('&');
            },

            getByName : function (name) {
                for (var key in this.routes) {
                    if (this.routes.hasOwnProperty(key) && this.routes[key].name === name) {
                        return this.routes[key];
                    }
                }
            },

            getByAction : function(action) {
                for (var key in this.routes) {
                    if (this.routes.hasOwnProperty(key) && this.routes[key].action === action) {
                        return this.routes[key];
                    }
                }
            },

            getCorrectUrl: function (uri) {
                var url = this.prefix + '/' + uri.replace(/^\/?/, '');

                if(!this.absolute)
                    return url;

                return this.rootUrl.replace('/\/?$/', '') + url;
            }
        };

        var getLinkAttributes = function(attributes) {
            if ( ! attributes) {
                return '';
            }

            var attrs = [];
            for (var key in attributes) {
                if (attributes.hasOwnProperty(key)) {
                    attrs.push(key + '="' + attributes[key] + '"');
                }
            }

            return attrs.join(' ');
        };

        var getHtmlLink = function (url, title, attributes) {
            title      = title || url;
            attributes = getLinkAttributes(attributes);

            return '<a href="' + url + '" ' + attributes + '>' + title + '</a>';
        };

        return {
            // Generate a url for a given controller action.
            // laroute.action('HomeController@getIndex', [params = {}])
            action : function (name, parameters) {
                parameters = parameters || {};

                return routes.route(name, parameters, routes.getByAction(name));
            },

            // Generate a url for a given named route.
            // laroute.route('routeName', [params = {}])
            route : function (route, parameters) {
                parameters = parameters || {};

                return routes.route(route, parameters);
            },

            // Generate a fully qualified URL to the given path.
            // laroute.route('url', [params = {}])
            url : function (route, parameters) {
                parameters = parameters || {};

                return routes.url(route, parameters);
            },

            // Generate a html link to the given url.
            // laroute.link_to('foo/bar', [title = url], [attributes = {}])
            link_to : function (url, title, attributes) {
                url = this.url(url);

                return getHtmlLink(url, title, attributes);
            },

            // Generate a html link to the given route.
            // laroute.link_to_route('route.name', [title=url], [parameters = {}], [attributes = {}])
            link_to_route : function (route, title, parameters, attributes) {
                var url = this.route(route, parameters);

                return getHtmlLink(url, title, attributes);
            },

            // Generate a html link to the given controller action.
            // laroute.link_to_action('HomeController@getIndex', [title=url], [parameters = {}], [attributes = {}])
            link_to_action : function(action, title, parameters, attributes) {
                var url = this.action(action, parameters);

                return getHtmlLink(url, title, attributes);
            }

        };

    }).call(this);

    /**
     * Expose the class either via AMD, CommonJS or the global object
     */
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return laroute;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = laroute;
    }
    else {
        window.laroute = laroute;
    }

}).call(this);

